import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers";
import { StateAction } from "../../../utils/typeAlias";
import { BaseDateValidationProps } from "@mui/x-date-pickers/internals";
import { useTranslation } from "react-i18next";
import FormInput from "../form/FormInput";
import { useState } from "react";
import { dateLocales } from "../../../i18n";


interface WeekDateSelectionProps extends BaseDateValidationProps<Date> {
    start: Date;
    setStart: StateAction<Date>;
    end: Date | undefined;
    setEnd: StateAction<Date | undefined>;
    labelName?: string;
    sameDaySelection?: boolean;
    disableHighlightToday?: boolean;
    onChange?: () => void;
}

export default function DateTimeRangeSelect({
    start,
    setStart,
    end,
    setEnd,
    sameDaySelection,
    onChange,
    ...other
}: WeekDateSelectionProps) {
    const { t, i18n } = useTranslation();
    const [labelWidth, setLabelWidth] = useState(0);

    return (
        <LocalizationProvider
            adapterLocale={dateLocales.get(i18n.language)}
            dateAdapter={AdapterDateFns}
        >
            <FormInput
                label={t("header.from")}
                sx={{ marginY: "auto", paddingBottom: { xs: 2, sm: 0 } }}
                onWidthChange={setLabelWidth}
            >
                <DateTimePicker
                    {...other}
                    disableFuture
                    value={start}
                    onChange={(selectedDate) => {
                        if (!selectedDate) return;

                        setStart(selectedDate);
                        onChange && onChange();
                    }}
                    closeOnSelect={false}
                />
            </FormInput>
            <FormInput
                label={t("header.to")}
                sx={{ marginY: "auto" }}
                labelWidth={labelWidth}
            >
                <DateTimePicker
                    sx={{ marginTop: { sm: 0.5 } }}
                    value={end}
                    minDate={start}
                    disableFuture
                    onChange={(selectedDate) => {
                        if (!selectedDate) return;

                        setEnd(selectedDate);
                        onChange && onChange();
                    }}
                ></DateTimePicker>
            </FormInput>
        </LocalizationProvider>
    );
}
